import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { BudgetService } from '../../../service/budget.service';
import { ProviderService } from '../../../service/provider.service';
import { BudgetMonthComponent } from '../budget-month/budget-month.component';
import { BudgetDetailBudgetComponent } from '../budget-detail-budget/budget-detail-budget.component';
import { formatNumber } from '@angular/common';

@Component({
  selector: 'app-budget-item-manager',
  templateUrl: './budget-item-manager.component.html',
  styleUrls: ['./budget-item-manager.component.less']
})
export class BudgetItemManagerComponent implements OnInit {

  constructor(
    private budgetService: BudgetService,
    private providerService: ProviderService,
    private fb: FormBuilder,
    private nzMessageService: NzMessageService,
    private modalService: NzModalService,
    @Inject(LOCALE_ID) private localeId: string
  ) { }

  @Input() code = 0; // 0表示新建 1表示编辑
  @Input() bid: any; // 预算编号

  budget = null;
  beforeValue = '';
  typeMap = new Map<number, any>();
  pTypes = [];
  directors = [];
  bstatus = [];
  validateForm: FormGroup;

  listOfParentData: any[] = [];
  list: any[] = [];

  // 未归类明细
  listOfData: any[] = [];
  yearCurrentValue = 0;
  yearActualValue = 0;
  yearBudget = {
    expand: false,
    bname: `年度预算`,
    currentValue: 0,
    actualValue: 0,
    sum: 0,
    flag: false,
    detailMonths: []
  };

  formatter = (value: number): string => {
    return formatNumber(value, this.localeId, '1.2-2');
  }

  async ngOnInit() {

    this.validateForm = this.fb.group({
      bname: [null, [Validators.required]],
      bid: [{ value: null, disabled: true }],
      currentValue: [{ value: 0, disabled: true }],
      director: [null, [Validators.required]],
      status: [null],
      byear: [null, [Validators.required]],
      mark: [null],
    });
    this.loadData();

    this.initBudgetStatus();

    this.initDirectors();

    if (this.code === 1 || this.code === 2) {

      // 从后端查询一条记录然后填充budget变量
      this.budgetService.getBudget(this.bid).then((data) => {
        this.budget = data;
        // 将填充好数据的budget变量传入表单的set方法
        this.setValidateForm(this.budget);
        if (this.code === 2) {
          // 根据父组件传值来决定是否禁用整个表单
          this.validateForm.disable();
        }
      });

    }


  }


  /**
   * 加载数据
   */
  async loadData() {
    if (this.bid === undefined || this.bid === null){
      return;
    }
    // budgetMonth 包含月度明细的budget
    let yearCurrentValue = 0;
    let yearActualValue = 0;
    const budget = await this.budgetService.getMonthsDetailsByBid(this.bid);
    budget.budgetMonths.forEach((item: any) => {
      let cvalue = 0;
      let avalue = 0;
      item.detailMonths.forEach((detail: any) => {
        cvalue = cvalue + detail.initValue;
        avalue = avalue + detail.actualValue;
        // 统计信息
        yearCurrentValue = yearCurrentValue + detail.initValue;
        yearActualValue = yearActualValue + detail.actualValue;
      });
      const value = { currentValue: cvalue, actualValue: avalue };
      // this.yearCurrentValue = this.yearCurrentValue + cvalue;
      // this.yearActualValue = this.yearActualValue + avalue;

      Object.assign(item, value);
      const expand = { expand: false };
      Object.assign(item, expand);
      // flag 是否加载操作栏
      const flag = { flag: true };
      Object.assign(item, flag);
    });

    this.yearCurrentValue = yearCurrentValue;
    this.yearActualValue = yearActualValue;

    // 对年度预算下的月度预算进行排序
    const array: any[] = budget.budgetMonths;
    array.sort(this.sortData);

    // 获取年度预算下的所有明细
    const budgetYear = await this.budgetService.getBudgetWithPrice(this.bid);
    const detailsYear = budgetYear.budgetDetails;
    if (detailsYear !== undefined && detailsYear.length !== 0) {
      let sum = 0;
      detailsYear.forEach((item: any) => {
        sum = sum + item.initValue;
      });
      this.yearBudget = {
        expand: false,
        bname: `年度预算`,
        currentValue: this.yearCurrentValue,
        actualValue: this.yearActualValue,
        sum,
        flag: false,
        detailMonths: budgetYear.budgetDetails
      };
      budget.budgetMonths.push(this.yearBudget);
    }

    this.listOfParentData = budget.budgetMonths;

  }

  // 月度预算根据bmonth属性排序(从大到小)
  sortData(a: any, b: any) {
    return b.bmonth - a.bmonth;
  }

  async edit(mbid: any) {
    const modal = this.modalService.create({
      nzTitle: '月度预算',
      nzContent: BudgetMonthComponent,
      nzWidth: 700,
      nzComponentParams: {
        mbid,
        bid: this.bid
      },
      // 当nzContent时组件时，ev就是该组件，可以通过ev访问属性和调用方法
      nzOnOk: async (ev) => {
        const flag = await ev.edit();
        if (flag) {
          this.nzMessageService.info('修改成功');
        } else {
          this.nzMessageService.info('修改失败');
        }
        this.loadData();
      },
      nzOnCancel: (ev) => {
        // 对话框关闭
        console.log('nzOnCancel');
      },
    });
  }

  async add() {
    const modal = this.modalService.create({
      nzTitle: '月度预算',
      nzContent: BudgetMonthComponent,
      nzWidth: 630,
      nzComponentParams: {
        bid: this.bid,
        byear: this.budget.byear
      },
      // 当nzContent时组件时，ev就是该组件，可以通过ev访问属性和调用方法
      nzOnOk: async (ev) => {
        const flag = await ev.check();
        if (flag) {
          this.nzMessageService.info('添加成功');
        } else {
          this.nzMessageService.info('添加失败');
        }
        this.loadData();
      },
      nzOnCancel: (ev) => {
        // 对话框关闭
        console.log('nzOnCancel');
      },
    });
  }

  async del(mbid: any) {
    const result = await this.budgetService.deleteByMbid(mbid);
    if (result.data) {
      this.nzMessageService.info('删除成功');
      // 刷新页面数据
      this.loadData();
    } else {
      this.nzMessageService.info('删除失败');
    }
  }

  async relevance(data: any) {
    const modal = this.modalService.create({
      nzTitle: `月度预算管理`,
      nzContent: BudgetDetailBudgetComponent,
      nzWidth: 900,
      nzFooter: null,
      nzComponentParams: {
        detailMonth: data
      }
    });
    // 消息框关闭后执行
    modal.afterClose.subscribe(() => {
      this.loadData();
    });
  }

  cancel(): void {
    this.nzMessageService.info('click cancel');
  }

  initBudgetStatus() {
    this.budgetService.getBudgetStatus().subscribe((data) => {
      this.bstatus = data;
    });
  }
  async initDirectors() {
    await this.providerService.getDirectors().then((data) => {
      this.directors = data;
    });
  }

  // 表单的的set方法
  setValidateForm(budget: any) {
    this.validateForm.get('bname').setValue(!this.isEmpty(budget.bname) ? budget.bname : null),
      this.validateForm.get('bid').setValue(!this.isEmpty(budget.bid) ? budget.bid : null),
      this.validateForm.get('currentValue').setValue(!this.isEmpty(budget.currentValue) ? budget.currentValue : null),
      this.validateForm.get('byear').setValue(!this.isEmpty(budget.byear) ? budget.byear : null),
      this.validateForm.get('status').setValue(!this.isEmpty(budget.status) ? budget.status : null),
      this.validateForm.get('director').setValue(!this.isEmpty(budget.director) ? budget.director : null),
      // tslint:disable-next-line:semicolon
      this.validateForm.get('mark').setValue(!this.isEmpty(budget.mark) ? budget.mark : null)
    // this.validateForm.controls.comprehensiveEvaluation.disable()
  }

  getBudgetForm() {
    return this.validateForm;
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
